import type { LegendProps } from '../../core/types/legend.js';

/**
 * Props for the TimeseriesChart.Legend slot component
 * @public
 */
export type TimeseriesChartLegendProps = LegendProps;

/**
 * @public
 */
export const Legend = (props: TimeseriesChartLegendProps) => null;

Legend['displayName'] = 'TimeseriesChart.Legend';
